export const DJANGO_API = process.env.REACT_APP_DJANGO_API;
export const FLASK_API = process.env.REACT_APP_FLASK_API;
export const tenant = window.location.hostname.split(".")[0];


export const doc = () => {
  const session = JSON.parse(localStorage.getItem("user_session") || "{}");
  const { tenant_id, appId } = session;

};

export const transformToTable = (rawDocs, originalJson = null) => {
  return {
    type: "table",
    id: "defaultTable",
    // 1. Original source kept for reference
    src: originalJson || rawDocs, 
    
    // 2. View State (Default pagination and selection)
    view: { 
      page: 1,
      pageSize: 10,
      sortBy: "row_id",
      sortDir: "asc",
      filters: {},
      hiddenColumns: [],
      selectedCells: [], 
      focusedCell: null,
      anchorCell: null 
    },

    // 3. Column Definition List (CVL)
    cvl: [
      { name: "Actions", type: "buttonList" },
      { name: "Seq", type: "sequence" },
      { name: "ItemID", type: "text", locked: true },
      { name: "Category", type: "select", options: [
        { label: "Hardware", value: "hardware" }, 
        { label: "Software", value: "software" }, 
        { label: "Service", value: "service" }
      ]},
      { name: "Status", type: "select", options: [
        { label: "Open", value: "open" }, 
        { label: "Closed", value: "closed" }
      ]},
      { name: "Amount", type: "number", agg: "sum" },
      { name: "row_id", type: "number", agg: "count" }
    ],

    // 4. Data Transformation
    data: rawDocs.map((item, index) => ({
      row_id: item.row_id || index + 100,
      meta: { 
        selected: false, 
        expanded: false 
      },
      row: {
        Actions: item.actions || ["edit"],
        Seq: index + 1,
        ItemID: item.itemId || `Item-${index}`,
        Category: item.category || "service",
        Status: item.status || "open",
        Amount: item.amount || 0,
        row_id: item.row_id || index + 100
      }
    }))
  };
};

export const CreateUserObject = (rawData = {}) => {
  // 1. If Django sent a string, turn it into a real Object
  let data = rawData;
  if (typeof rawData === 'string') {
    try {
      data = JSON.parse(rawData);
    } catch (e) {
      console.error("Failed to parse user data string", e);
    }
  }

  // 2. Build the Class structure
  return {
    baseUrl: "https://dashboard.bimzereg.com",
    name: data.username || data.name || "",
    // Map 'access' from Django to your 'token' key
    token: data.access || data.token || "", 
    refresh: data.refresh || "",
    userRole: data.userRole || "viewer",
    // Projects is now a real nested object/list, not a string
    projects: data.projects || data.cont_project || [], 
    ...data // Keep all the cont_id, cont_name, etc.
  };
};


// api.js
// All imports should be at the top (no axios needed now)

export const loginUser = async (username, password) => {
  const response = await fetch(`${DJANGO_API}/auth/api/token/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // credentials: "include", // 🔐 IMPORTANT
    body: JSON.stringify({
      username,
      password,
      host: window.location.hostname, // 🔹 send the host
    }),
  });

  if (!response.ok) throw new Error("Login failed");
  return response.json();
};

// api.js

// This function gathers your credentials (from localStorage, cookies, etc.)
const getHeaders = () => {
  const session = JSON.parse(localStorage.getItem("user_session") || "{}");
  const { token, tenant_id, tenant_db, appId, userRole } = session;

  const headers = {
    'Content-Type': 'application/json',
    'X-App-ID': appId || 'default', // Fallback if missing
  };

  // Only add auth headers if the token actually exists
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    headers['X-Tenant-ID'] = tenant_id?.toString();
    headers['X-Tenant-DB'] = tenant_db;
    headers['X-User-Role'] = userRole;
  }

  return headers;
};


// This is your global wrapper
export const apiRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    // 1. Set GET as the default method
    method: 'GET',    
    // 2. Overwrite with whatever is passed in (like 'POST')
    ...options,
    headers: {
      ...getHeaders(),
      ...options.headers, // Allows you to add/override headers if needed
    },
  });

  if (!response.ok) {
    // Flask usually returns error messages in JSON: { "msg": "Token expired" }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.msg || `API Error: ${response.status}`);
  }

  return response.json();
};


// Example: get tenants list
export const getTenants = async (user) => {

    // 🚀 DEBUG: Check if these are actually strings or 'undefined'
  console.log("Header Check:", {
    tenant: user?.tenant_id,
    db: user?.tenant_db,
    app: user?.appId,
    role: user?.userRole
  });

  try {
          
      const url = `/api/me/info`;
      const response = await fetch(url, {
      method: 'POST',
      headers: { 
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,// <-- send JWT
        'X-Tenant-ID': user.tenant_id.toString(),  // Add the tenant_id header
        'X-App-ID': user.appId,        // Add the app_id header
        'X-User-Role': user.userRole,   // Add the user_role header
        'X-Tenant-DB': user.tenant_db,  // Add the tenant_id header
      },
    });


   // If Django returns HTML (React index), log it
    const contentType = response.headers.get("content-type");
    if (!response.ok) {
     
      throw new Error(`Failed to fetch tenants: ${response.status}`);
    } else if (contentType && contentType.indexOf("application/json") === -1) {
      const text = await response.text();
      console.error("Unexpected HTML response:", text.substring(0, 200));
      throw new Error("Expected JSON but got HTML");
    }

    const data = await response.json();
    console.log("Tenants fetched:", data);
    return data; // e.g., { tenants: [], role: "admin" }
  } catch (error) {
    console.error('Error fetching tenants:', error);
    throw error;
  }
};
// Example: generic GET request
export const fetchData = async (url, token) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });

    if (!response.ok) throw new Error(`Request failed: ${response.status}`);

    return await response.json();
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const getTenantNotebook = async (
  tenant,
  project,
  section,
  notebook = "notebook1",
  page = "page1",
  folder = "home"
) => {
  // 1. Get the one string we saved
  const session = JSON.parse(localStorage.getItem("user_session") || "{}");

  // 2. Destructure exactly what you need
  const { token, tenant_id, tenant_db, appId, userRole } = session;

  if (!token) throw new Error("No active session");


  const url = `/api/${project}/${section}/${notebook}/${page}/${folder}/get-notebook`;

  const res = await fetch(url, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`, // <-- send JWT
      'X-Tenant-ID': tenant_id.toString(),  // Add the tenant_id header
      'X-App-ID': appId,        // Add the app_id header
      'X-User-Role': userRole,   // Add the user_role header
      'X-Tenant-DB': tenant_db,  // Add the tenant_id header
    },
    body: JSON.stringify({tenant}),
  });

  if (!res.ok) {
    if (res.status === 401 || res.status === 422) {
      throw new Error("JWT invalid or expired. Please login again.");
    }

    const errorData = await res.json().catch(() => ({}));
    throw new Error(`Flask API failed with status ${res.status}: ${errorData.msg || errorData.detail || "Unknown error"}`);
  }
  return res.json();
};
/**
 * Fetch page-level dataset
 * Example route: /get-page-dataset
 */
export const getPageDataset = async (
  tenant,
  project,
  section,
  notebook = "notebook1",
  page = "page1",
  folder = "home"
) => {

  // 1. Get the one string we saved
  const session = JSON.parse(localStorage.getItem("user_session") || "{}");

  // 2. Destructure exactly what you need
  const { token, tenant_id, tenant_db, appId, userRole } = session;

  if (!token) throw new Error("No active session");
  
  const url = `/api/${project}/${section}/${notebook}/get-page-dataset`;

  const res = await fetch(url, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,// <-- send JWT
      'X-Tenant-ID': tenant_id.toString(),  // Add the tenant_id header
      'X-App-ID': appId,        // Add the app_id header
      'X-User-Role': userRole,   // Add the user_role header
      'X-Tenant-DB': tenant_db,  // Add the tenant_id header
    },

    body: JSON.stringify({ 
      "tenant": tenant,   // key "tenant" maps to your tenant value
      "page": page, 
      "folder": folder  // key "folder" maps to the folder path
    }),
  });

  if (!res.ok) throw new Error("Failed");
  const json = await res.json();   // ⭐ wait for data
  console.log("PAGEDATASET:", json);

  return json;
};


/**
 * Update dataset for a specific page
 */
export const updatePageDataset = async (pageId, dataset, folder = "home") => {
  // 1. Get the one string we saved
  const session = JSON.parse(localStorage.getItem("user_session") || "{}");

  // 2. Destructure exactly what you need
  const { token, tenant_id, tenant_db, appId, userRole } = session;

  if (!token) throw new Error("No active session");

  const res = await fetch(`/api/update-page-dataset`, {
    method: "POST",
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'X-Tenant-ID': tenant_id.toString(), // Use the local variable
      'X-App-ID': appId,                 // Use the local variable
      'X-User-Role': userRole            // Use the local variable
    },
    body: JSON.stringify({ pageId, dataset, folder }),
  });

  if (!res.ok) {
    console.error(`Failed to update dataset for page ${pageId}`);
    throw new Error(`Dataset update failed with status ${res.status}`);
  }

  return res.json();
};

/**
 * Example Django data call (unchanged)
 */
export async function getDjangoData() {
  const url = `${DJANGO_API}/api/tenants/react`;
  console.log("Fetching Django API from:", url);
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Django API failed: ${res.status}`);
  return res.json();
}

/**
 * Example Flask data call (unchanged)
 */
export async function getFlaskData() {
  const res = await fetch(`${FLASK_API}/api/sample-data`);
  if (!res.ok) throw new Error("Flask API failed");
  return res.json();
}

